import { JSX } from 'react';

import { ContentWrapper } from '../content-wrapper';
import { useStyles } from './header.styles';
import { LanguageSwitcher } from '../language-switcher';

export const Header = (): JSX.Element => {
  const classes = useStyles();

  return (
    <ContentWrapper>
      <header className={classes.root} data-testid="header">
        <LanguageSwitcher />
      </header>
    </ContentWrapper>
  );
};
